<template>
  <div class="billing-reference">
    <div class="input-content">
      <input
        type="text"
        v-model="billingReference"
        class="input-content__input"
        placeholder="Billing Reference"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "BillingReference",
  props: {
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      billingReference: ""
    };
  },
  watch: {
    billingReference(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      this.billingReference = newValue || "";
    }
  },
  created() {
    this.billingReference = this.value || "";
  }
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;

.billing-reference {
  text-align: start;

  &__info {
    font-weight: 400;
    font-size: 12px;
    margin-top: 5px;
    display: block;
  }
}

.input-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__text {
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 8px;
    color: $color-primary-company;
  }

  &__input {
    width: 100%;
    height: 40px;
    padding: 8px 12px;
    border: 1px solid $color-border-container;
    border-radius: 8px;
    background: $color-white;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s ease;

    &:focus {
      border-color: $color-border-container;
    }

    &:disabled {
      background: $color-gray;
      cursor: not-allowed;
    }

    &::placeholder {
      color: $color-gray;
    }
  }
}
</style>
